import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom validator for key fields.
 * Ensures the value is all lowercase, has no whitespace, no special characters, and is unique.
 * @param currentGeoKeys Array of existing keys to ensure uniqueness.
 * @returns Validator function that checks the control value.
 */
export function districtKeyValidator(
  currentGeoKeys?: (string | number)[]
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    return validateKeyValue(value, currentGeoKeys);
  };
}
export function validateKeyValue(
  value: string | number,
  existingKeys?: (string | number)[]
) {
  let errors: ValidationErrors = {};

  if (!value) {
    errors = { ...errors, ...{ required: true } };
  }

  // Check for lowercase letters only
  if (typeof value === 'string' && value !== value.toLowerCase()) {
    errors = { ...errors, ...{ lowercaseRequired: true } };
  }

  // Check for no whitespaces
  //if (/\s/.test(value)) {
  //  errors = { ...errors, ...{ whitespaceNotAllowed: true } };
  //}

  // Check for no special characters (only allow alphanumeric)
  if (typeof value === 'string' && /[^a-z0-9_\s]/.test(value)) {
    errors = { ...errors, ...{ noSpecialCharsAllowed: true } };
  }

  if (existingKeys && existingKeys.length && !existingKeys.includes(value)) {
    errors = { ...errors, ...{ notIncluded: true } };
  }

  return Object.keys(errors).length ? errors : null;
}
